(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-home-produits"] && !Shopify.designMode) return;
  try {
    
// Charge une seule fois le script d'ajout au panier, quel que soit le nombre
// de rangées de produits présentes sur la page.
(function () {
  if (window.__clAtcLoaded) return;
  var host = document.querySelector('[data-cl-atc-src]');
  if (!host) return;
  window.__clAtcLoaded = true;
  var s = document.createElement('script');
  s.src = host.getAttribute('data-cl-atc-src');
  s.defer = true;
  document.head.appendChild(s);
})();

  } catch(e) { console.error(e); }
})();
})();
